import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';
import { LeakDetectionMode } from '@app/core/enums/leak-detection-mode.enum';
import { LeakDetectionStatus } from '@app/core/enums/leak-detection-status.enum';

export interface ILoggerMeasurementPrediction {
  value?: number;
  status?: LeakDetectionStatus;
}

/** Picks the Leak Score or AI Predictor pair off a measurement, per the project's prediction setting; a `null` from the backend comes back as `undefined`. */
export function getLoggerMeasurementPrediction(
  measurement: ILoggerMeasurement | undefined,
  leakDetectionMode: LeakDetectionMode
): ILoggerMeasurementPrediction {
  return leakDetectionMode === LeakDetectionMode.LeakScore
    ? { value: measurement?.leakScore ?? undefined, status: measurement?.leakScoreStatus ?? undefined }
    : { value: measurement?.leakAiPredictor ?? undefined, status: measurement?.leakAiPredictorStatus ?? undefined };
}
